<template>
  <nav>
    <ul :style="show_menu ? 'height: auto' : ''" @click.prevent="toggleMenu" class="menu" id="menu">
      <li>
        <a href> <i :class="'fa fa-' + (show_menu ? 'times' : 'bars')"></i> MENU </a>
      </li>

      <router-link :key="index" :to="item.link" tag="li" v-for="(item, index) in filteredSchema">
        <a>
          <i :class="'fa fa-' + item.icon"></i>
          {{ item.title }}
        </a>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "NavMenu",
  data: function () {
    return {
      show_menu: false
    }
  },
  computed: {
    schema: function () {
      return this.$store.state.display.leftMenu
    },
    filteredSchema() {
      var username = this.$store.getters["user/username"]
      var user = this.$store.state.user.user
      return this.$store.state.display.leftMenu.filter((page) => {
        if (!page.hide_for && !page.master) return true

        if (page.hide_for && page.hide_for.filter((p) => p == username).length) return false
        if (
          page.master &&
          !(
            user["cognito:groups"] &&
            user["cognito:groups"].length &&
            user["cognito:groups"].filter((g) => g == "master").length
          )
        )
          return false

        return true
      })
    }
  },
  methods: {
    toggleMenu: function () {
      this.show_menu = !this.show_menu
    }
  }
}
</script>
